import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { RequestTypes } from '../requestTypes'
import { taskTemplateKeys } from '../taskTemplateKeys'
import { TaskTemplate, ITaskTemplate } from '@core/entities/task/TaskTemplate'
import { PageResponse } from '@core/entities/pagination'
import { RequestErrorType } from '@core/utils/api-axios-instance'

const dataTransformer = (response: PageResponse<ITaskTemplate>) => {
  return {
    ...response,
    content: response.content.map((template) => TaskTemplate.new(template)),
  }
}

export const useGetTaskTemplates = (
  payload: RequestTypes['getTaskTemplates'],
  options?: UseQueryOptions<
    PageResponse<ITaskTemplate>,
    RequestErrorType,
    PageResponse<TaskTemplate>
  >,
) => {
  return useQuery<
    PageResponse<ITaskTemplate>,
    RequestErrorType,
    PageResponse<TaskTemplate>
  >({
    select: dataTransformer,
    ...taskTemplateKeys.byOrganisation(payload),
    ...options,
  })
}
